<div class="wrap-1200">
  <app-ir-approved-table
    [projectData]="irApproved"
    [loader]="loader"
    (reloadDataEmitter)="getIrApproved()"
  ></app-ir-approved-table>
</div>